import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { Alert } from '@bingads-webui-react/alert';
import { HelpLink } from '@bingads-webui-react/help-link';

export const NoInitialDataAlert = () => {
  const i18n = useContext(I18nContext);
  return (
    <Alert
      message={
        <>
          {i18n.getString(_TL_('Before you can start personalizing your ads, you’ll need to add a page feed for your products or services.'))} <HelpLink query="help:app54621">{i18n.getString(_TL_('Learn more'))}</HelpLink>
        </>
      }
      level="Warning"
      icon={(<div className="alert-image" />)}
      dismissible={false}
    />
  );
};

export const SystemErrorAlert = () => {
  const i18n = useContext(I18nContext);
  return (
    <Alert
      message={i18n.getString(_TL_('We cannot load your page feeds at this time. Please try again later.'))}
      level="Error"
      icon={(<div className="alert-image" />)}
      dismissible={false}
    />
  );
};

export const MaxSelectionAlert = ({ selectedOptionsLimit }) => {
  const i18n = useContext(I18nContext);
  return (
    <Alert
      message={i18n.getString(_TL_('You can only add up to {{selectedOptionsLimit}} page feeds per campaign. Please review your selections and try again.'), { selectedOptionsLimit })}
      level="Warning"
      icon={(<div className="alert-image" />)}
      dismissible={false}
    />

  );
};

MaxSelectionAlert.propTypes = {
  selectedOptionsLimit: PropTypes.number.isRequired,
};

export const MoreOptionsInlineAlert = ({ optionsLimit }) => {
  const i18n = useContext(I18nContext);
  return (
    <Alert
      message={i18n.getString(_TL_('We only display the first {{optionsLimit}} page feeds. Please refine your search to find the specific page feed.'), { optionsLimit })}
      level="Info"
      icon={null}
      dismissible={false}
    />
  );
};

MoreOptionsInlineAlert.propTypes = {
  optionsLimit: PropTypes.number.isRequired,
};

export const NoDataInlineAlert = ({ searchFilter }) => {
  const i18n = useContext(I18nContext);
  return (
    <div className="page-feed-selector-no-options">
      {searchFilter &&
        <span>{i18n.getString(_TL_('No results found'))}</span>
      }
      {!searchFilter &&
        <span>{i18n.getString(_TL_('Once you add page feeds, they’ll appear in the dropdown.'))}</span>
      }
    </div>
  );
};

NoDataInlineAlert.propTypes = {
  searchFilter: PropTypes.string,
};

NoDataInlineAlert.defaultProps = {
  searchFilter: undefined,
};
